import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import SearchPlans from "./SearchPlans";
import FavoritePlans from "./FavoritePlans";
import ShoppingCart from './ShoppingCart';
import AboutPage from "./AboutPage";
import ContactPage from "./ContactPage";
import { FaSearch, FaStar, FaInfo, FaShoppingCart, FaPhone } from 'react-icons/fa';
//import "react-tabs/style/react-tabs.css";
import '../css/tabs.css';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0
        }
    }

    render() {
        return (
            <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
                <TabList>
                    <Tab><FaSearch /></Tab>
                    <Tab><FaStar /></Tab>
                    <Tab><FaShoppingCart /></Tab>
                    <Tab><FaInfo /></Tab>
                    <Tab><FaPhone /></Tab>
                </TabList>

                <TabPanel forceRender>
                    <SearchPlans />
                </TabPanel>

                <TabPanel>
                    <FavoritePlans />
                </TabPanel>

                <TabPanel>
                    <ShoppingCart />
                </TabPanel>

                <TabPanel>
                    <AboutPage />
                </TabPanel>

                <TabPanel>
                    <ContactPage />
                </TabPanel>

            </Tabs>
        )
    }

    getUrlVars = () => {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }

    componentDidMount() {
        if (this.getUrlVars()["type"] == "cart") {
            this.setState({ tabIndex: 2 });
        }
    }
}

export default Home;
